import React from "react";

const Result = ({ result }) => {
  return <div className="resultValue">{result}</div>;
};

export default Result;
